import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MatTooltip } from '@angular/material/tooltip';

import { SECTION_LABEL_CLASS } from '../ui/ui.classes';

/**
 * One labelled fact in a detail grid. Stacking the label above the value costs a line but lets
 * three facts sit across a phone screen, which reading them as `label: value` pairs does not.
 *
 * The leaf half of the pair {@link PanelSectionComponent} completes: a fact names one value and
 * truncates it to the grid's track, a section names a group and lets its content wrap.
 */
@Component({
  selector: 'guarantees-fact',
  standalone: true,
  imports: [MatTooltip],
  template: `
    <span class="flex min-w-0 flex-col gap-px">
      <span class="truncate {{ labelClass }}" [matTooltip]="hint()" [matTooltipDisabled]="!hint()">{{ label() }}</span>
      <span class="min-w-0 truncate text-sm text-neutral-700 tabular-nums"><ng-content /></span>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FactComponent {
  label = input.required<string>();
  hint = input<string>('');

  protected readonly labelClass = SECTION_LABEL_CLASS;
}
